import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { PacienteViewProps, mapDispatchToPacienteProps, mapStateToPacienteProps, pacienteController } from "../paciente.controller";
import { Autocomplete, Box, Button, Chip, IconButton, Stack, TextField, Typography } from "@mui/material";
import { FilterPaciente, Paciente } from "../paciente.model";
import { ArrowDropDown, Campaign, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsPaciente } from "./paciente.list";
import { StripedDataGrid, Select as ViewList } from "../../../components/select";
import { PacienteCadastro } from "./paciente.cad";
import { Atendimento } from "../../atendimento/atendimento.model";
import { GridColDef } from "@mui/x-data-grid";
import { formatTime } from "../../../services/utils";
import store from "../../../store";


interface PacienteAutoCompletProps extends PacienteViewProps {
    handleSelectPaciente: (row: Paciente) => any
}


function PacienteAutoComplete(props: PacienteAutoCompletProps) {
    const { pacienteActions, pacienteState, handleSelectPaciente } = props
    const { rows } = pacienteState
    useEffect(() => {
        console.log("chamou ")
        pacienteActions.read();
    }, [])

    const handleSelect = (row: Paciente) => {
        console.log("selecionou Paciente " + row)
        handleSelectPaciente(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(row) => row.nome}
            getOptionKey={(row) => row._id}
            title="Selecionar Paciente"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Paciente"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, paciente) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{paciente.nome}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar Paciente"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, paciente) => {
                ev.preventDefault();
                if (paciente)
                    handleSelect(paciente);
            }}
        />
    )
}
interface SelecionarPacienteProps extends PacienteViewProps {
    handleConfirmar: (paciente: Paciente) => any;
}

const SelecionarPaciente = memo((props: SelecionarPacienteProps) => {
    const { pacienteActions, pacienteState, handleConfirmar } = props
    const { error, loadingRows, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = pacienteState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = pacienteActions

    console.log("carregou Selecionar Paciente")
    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return PacienteCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
            width: "sm"
        })
    }

    const handleSelecionar = (paciente: Paciente) => {
        handleConfirmar(paciente);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Paciente"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Paciente) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    fieldSearch={"nome"}
                    placeholderTextSearch="Buscar paciente"
                    variantToobar="dense"
                    columns={columnsPaciente}
                    rows={rows}
                    loading={loadingRows}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Paciente) => <Typography component={"span"}>{row.nome}</Typography>}
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="xs"
            handleOnKeyDown={() => { }}
        />
    )
}, (prev, next) => {
    return prev.pacienteState.showSelectModal === next.pacienteState.showSelectModal &&
        prev.pacienteState.changeList === next.pacienteState.changeList
})

export default connect(mapStateToPacienteProps, mapDispatchToPacienteProps)(PacienteAutoComplete)
export const ViewSelecionarPaciente = connect(mapStateToPacienteProps, mapDispatchToPacienteProps)(SelecionarPaciente)

interface PacienteAtendimentoListProps extends PacienteViewProps {
    atendimento: Atendimento
    handleRowClick: (row: Paciente) => any
}

export const columnsPacienteAtend = (handleRowClick: (row: Paciente) => any): GridColDef[] => [
    { field: 'dt_hr_chegada', headerName: 'Chegou as', flex: 1, valueFormatter: (value, row: Paciente) => formatTime(row.dt_hr_chegada) },
    { field: 'nome', headerName: 'Paciente', flex: 1 },
    {
        field: 'situacao', headerName: 'Situação', flex: 1, renderCell: (prm) => {
            switch (prm.value) {
                case "AGUARDANDO":
                    return <Chip label={"Aguardando"} color="error" />
                default:
                    return <Chip label={prm.row.chamando?"Chamando...":"Chamado"} color={prm.row.chamando?"info":"success"} />
            }
        }
    },
    {
        field: '_id', headerName: 'Action', flex: 1, renderCell: (prm) => {
            return (
                <Button
                    variant="contained"
                    size="small"
                    color="error"
                    endIcon={<Campaign />}
                    onClick={() => handleRowClick(prm.row)}
                >
                    Chamar
                </Button>
            )
        }
    },

]

const PacienteAtendimentoList = memo((props: PacienteAtendimentoListProps) => {
    const { atendimento, handleRowClick, pacienteActions, pacienteState } = props
    const { loadingRows, rows_paciente_atendimento } = pacienteState
    return (
        <StripedDataGrid
            disableRowSelectionOnClick
            rows={rows_paciente_atendimento}
            columns={columnsPacienteAtend(handleRowClick)}
            getRowId={row => row._id}
            density={'compact'}
            style={{ fontSize: '0.875rem' }}
            hideFooterPagination={true}
            hideFooter={true}
            filterMode="client"
            loading={loadingRows}
        />
    )
}, (prev, next) => {
    return prev.pacienteState.changeList === next.pacienteState.changeList
})
export const PacienteAtendimentoListView = connect(mapStateToPacienteProps, mapDispatchToPacienteProps)(PacienteAtendimentoList)

export const handleReadPacientesByAtendimento = (row: Atendimento) => {
    store.dispatch(pacienteController.reducer.actions.readPacientesByAtendimento(row))
}

export const handleSetFiltroPaciente = (filtro: FilterPaciente) => {
    store.dispatch(pacienteController.reducer.actions.setFiltro(filtro))
}

export const handleSelecionarPaciente = (set: boolean) => {
    store.dispatch(pacienteController.reducer.actions.setShowSelectModal(set));
    if (pacienteController.state.rows.length === 0)
        store.dispatch(pacienteController.reducer.actions.read())
}